
<div v-if="!(isSet || bannerHidden)"
  id="cookies-banner"
  class="font-rubik flex flex-col min-w-0 min-h-0"
  :class="[
    { 'max-[768px]:!w-full max-[768px]:!h-full max-[768px]:!rounded-none max-[768px]:!left-0': isCookiePreferencesOpen}
  ]"
>
  <template v-if="!isCookiePreferencesOpen">
    <a id="close-cookies-banner"><img src="@/images/cookies/close.svg" alt="Close" @click="close" /></a>

    <p class="mb-5">
      By clicking “Accept all cookies”, you agree to the storing of cookies
      on your device to enhance site navigation, analyze site usage, and
      assist in our marketing efforts. <b>We also collect location data to
      tailor our product and solution offerings to better meet your
      needs</b>. View our <a :href="privacyPolicyUrl"><u>Privacy Policy</u></a> for more information.
    </p>
  </template>
  <template v-else>
    <div class="flex flex-col gap-6 mb-[1.5rem] shrink min-w-0 min-h-0">
      <button
        class="m-0 p-0 w-[2rem] h-[2rem] flex items-center justify-center absolute top-[0.75rem] right-[0.75rem]"
        @click="close"
      >
        <img src="@/images/cookies/close.svg" alt="Close" />
      </button>
      <h4 class="text-[2rem] leading-[2.625rem] max-[1024px]:text-[1.5rem] max-[1024px]:leading-[2.125rem]">
        Privacy Preferences
      </h4>
      <div class="shrink py-8 flex flex-col gap-8 border-y border-[#EDE9E3] overflow-y-auto">
        <div class="flex flex-col gap-2">
          <div class="flex gap-4 justify-between items-center">
            <span class="text-[1.25rem] leading-[1.5rem] max-[1024px]:text-[1.125rem]">Essential</span>
            <span class="text-[1rem] leading-[1.5rem] font-medium">Required</span>
          </div>
          <p class="text-[1rem] leading-[1.5rem]">
            These items are required to enable basic website functionality.
          </p>
        </div>
        <div class="flex flex-col gap-2">
          <div class="flex gap-4 justify-between items-center">
            <span class="text-[1.25rem] leading-[1.5rem] max-[1024px]:text-[1.125rem]">Marketing</span>
            <SliderCheckbox :value="cookiesPreferences.marketing" @input="setPreference('marketing')" />
          </div>
          <p class="text-[1rem] leading-[1.5rem]">
            These items are used to deliver advertising that is more relevant to you and your interests.
          </p>
        </div>
        <div class="flex flex-col gap-2">
          <div class="flex gap-4 justify-between items-center">
            <span class="text-[1.25rem] leading-[1.5rem] max-[1024px]:text-[1.125rem]">Personalization</span>
            <SliderCheckbox :value="cookiesPreferences.personalization" @input="setPreference('personalization')"/>
          </div>
          <p class="text-[1rem] leading-[1.5rem]">
            These items allow the website to remember choices you make (such as your user name, language, or the region you are in) and provide enhanced, more personal features.
          </p>
        </div>
        <div class="flex flex-col gap-2">
          <div class="flex gap-4 justify-between items-center">
            <span class="text-[1.25rem] leading-[1.5rem] max-[1024px]:text-[1.125rem]">Analytics</span>
            <SliderCheckbox :value="cookiesPreferences.analytics" @input="setPreference('analytics')"/>
          </div>
          <p class="text-[1rem] leading-[1.5rem]">
            These items help the website operator understand how its website performs, how visitors interact with the site, and whether there may be technical issues.
          </p>
        </div>
      </div>
    </div>
  </template>

  <div class="flex mb-[2rem] gap-3 max-[1024px]:flex-col max-[1024px]:gap-4">
    <button
      class="border border-[#4D84FF] rounded-full h-[2.75rem] px-6 bg-[#4D84FF] text-white text-[1rem] leading-[1.5rem] flex items-center justify-center w-full"
      @click="acceptAll"
    >Accept all cookies</button>
    <button
      class="border rounded-full h-[2.75rem] px-6 hover:bg-[#EEEEEE] text-[1rem] leading-[1.5rem] flex items-center justify-center w-full bg-white"
      @click="declineAll"  
    >Decline all cookies</button>
  </div>

  <div class="w-full flex justify-end">
    <button
      class="m-0 px-2 py-1 flex gap-1 rounded-full hover:bg-[#EEEEEE]"
      @click="toggleCookiePreferences"
    >
      <img
        src="@/images/cookies/cookie.svg"
        alt="Cookie"
      />
      Cookie Preferences
    </button>
  </div>
</div>
